import { generateClient } from "aws-amplify/api";
import { createPrice, updatePrice, deletePrice as removePrice } from "graphql/customs/mutations";
import { pricesByDate, getPrice as fetchPrice } from "graphql/queries";
import { cleanUpData, getDataFromResponse, getNotDeletedItems } from "utils/Api";
import { SEQUENCETYPES } from "utils/Constants";
import { sequenceGenerator } from "utils/Form";
import { getTypeCounterByName, increaseTypeCounter } from "./TypeCounterApi";

const API = generateClient();

export const savePrice = async (data) => {
    const operationName = (data && data.id) ? "update" : "create";
    const operation = operationName === "update" ? updatePrice : createPrice;
    let cleanData = cleanUpData(data);

    cleanData["type"] = "Price";

    let counter;
    if (operationName === "create") {
        counter = await getTypeCounterByName(SEQUENCETYPES.COST);
        const sequenceNumber = sequenceGenerator(SEQUENCETYPES.COST, counter);
        cleanData = {
            ...cleanData,
            secuencia: sequenceNumber
        };
    }

    const priceResponse = await API.graphql({
        query: operation,
        variables: {
            "input": cleanData
        }
    });
    if (operationName === "create") {
        await increaseTypeCounter(counter)
    }
    return getDataFromResponse(priceResponse, operationName === "create" ? "createPrice" : "updatePrice");
};

export const getPrices = async (filter = {}) => {
    const data = await API.graphql({
        query: pricesByDate,
        variables: {
            "filter": filter,
            "type": "Price",
            "sortDirection": "DESC"
        }
    })
    return getNotDeletedItems(data, "pricesByDate");
}


export const getUserPrices = async (filter = {}) => {
    const data = await API.graphql({
        query: pricesByDate,
        variables: {
            "filter": {...filter,  isPublic: { eq: true }, isActive: { eq: true }},
            "type": "Price",
            "sortDirection": "DESC"
        }
    })
    return getNotDeletedItems(data, "pricesByDate");
}

export const getPrice = async (priceId) => {
    let priceObject = await API.graphql({
        query: fetchPrice,
        variables: {
            id: priceId
        }
    });
    return getDataFromResponse(priceObject, "getPrice");
}

export const deletePrice = async (priceData) => {
    const deletedAsset = await API.graphql({
        query: removePrice,
        variables: {
            input: {
                "id": priceData.id,
            }
        }
    });
    return getDataFromResponse(deletedAsset, "deletePrice");
}